import type { ToolListState } from "./types";
export function readListState(
  params: URLSearchParams,
  stored: unknown,
  statuses: string[] = ["all"],
): ToolListState {
  const saved =
    stored && typeof stored === "object"
      ? (stored as Record<string, unknown>)
      : {};
  const get = (key: string) => (params.has(key) ? params.get(key) : saved[key]);
  const q = get("q"),
    status = get("status"),
    page = Number(get("page"));
  return {
    q: typeof q === "string" ? q.slice(0, 500) : "",
    status:
      typeof status === "string" && statuses.includes(status) ? status : "all",
    sort: get("sort") === "name" ? "name" : "updated",
    view: get("view") === "recent" ? "recent" : "projects",
    page: Number.isSafeInteger(page) && page > 0 ? page : 1,
  };
}
export function pageItems<T>(items: T[], requested: number, size = 25) {
  const pageCount = Math.max(1, Math.ceil(items.length / size));
  const page = Math.min(Math.max(1, requested), pageCount);
  return {
    items: items.slice((page - 1) * size, page * size),
    page,
    pageCount,
  };
}
